import type { ISinceParts } from './ISinceParts';

/**
 * Відносний час як `since` прототипу v4 (чиста функція): майбутнє й менше хвилини — «щойно»; до години — хвилини; до доби — години; до
 * 30 днів — дні; далі — дата. Майбутній час (нагадування на 09:00 дня терміну) теж «щойно», як у прототипі.
 */
export function sinceParts(atMs: number, nowMs: number): ISinceParts {
  const minutes = Math.round((nowMs - atMs) / 60000);
  if (!Number.isFinite(minutes) || minutes < 1) return { unit: 'now', count: 0 };
  if (minutes < 60) return { unit: 'min', count: minutes };
  const hours = Math.round(minutes / 60);
  if (hours < 24) return { unit: 'hour', count: hours };
  const days = Math.round(hours / 24);
  return days < 30 ? { unit: 'day', count: days } : { unit: 'date', count: 0 };
}
